import React from 'react';
import { View, StyleSheet, Image } from 'react-native';

import { CAPTION_TEXT } from '../constants/colors';
import { Text } from '../core-ui';

import { internalError } from '../../assets';

export default function DataNotFound() {
  let caption = 'Please contact the Project Manager for more information.';
  return (
    <View style={styles.container}>
      <Image source={internalError} style={styles.image} />
      <Text type="header" style={styles.headerText}>
        No data available
      </Text>
      <Text color={CAPTION_TEXT} style={styles.captionText}>
        {caption}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: 280,
    height: 280,
    marginBottom: 40,
  },
  headerText: {
    fontSize: 26,
    marginBottom: 16,
  },
  captionText: {
    textAlign: 'center',
    marginBottom: 16,
  },
});
